import React from 'react';
import cn from 'classnames';
import propTypes from 'prop-types';

import HabitCheckmarkIcon from '../Assets/Svgs/HabitCheckmarkIcon';

import './ColorButton.scss';

function ColorButton({ color, onClick, isCircle, isSelected, isEditable }) {
  const id = color.id;
  const hex = color.hex ?? color;

  return (
    <div className="color-button-wrapper">
      <button
        className={cn('color-button', { circle: isCircle })}
        data-id={id}
        data-color={hex}
        onClick={onClick}
        style={{ backgroundColor: hex }}
        aria-label={isSelected ? `${hex}, selected` : hex}
        aria-pressed={isSelected}
        type="button"
      >
        <HabitCheckmarkIcon className={cn('checkmark', { visible: isSelected })} />
      </button>
      {isEditable && (
        <button
          className="delete-icon-wrapper"
          onClick={onClick}
          data-id={id}
          data-color={hex}
          aria-label={`Remove color ${hex}`}
          type="button"
        >
          X
        </button>
      )}
    </div>
  );
}

ColorButton.propTypes = {
  color: propTypes.oneOfType([
    propTypes.string.isRequired,
    propTypes.shape({
      id: propTypes.string.isRequired,
      hex: propTypes.string.isRequired,
    }),
  ]),
  onClick: propTypes.func,
  isCircle: propTypes.bool,
  isSelected: propTypes.bool,
  isEditable: propTypes.bool,
};

ColorButton.defaultProps = {
  isCircle: false,
  isSelected: false,
  isEditable: false,
};

export default ColorButton;
